import { useContext } from "react";
import "./App.css";
import Loader from "../src/shared/Loader/Loader";
import { CommonContext } from "./context/CommonContext";
import Router from "./routes/routes"
import AlertBox from "./shared/AlertBox/AlertBox";

function App() {
  const { isLoading } = useContext(CommonContext)
  return (
    <>
      <Router />
      <Loader open={isLoading} />
      <AlertBox />
    </>
  );
}

export default App;
